import { RegionSelector } from "./theme/regionSelector";
import { CareSelector } from "./theme/careSelector";
RegionSelector.init();
CareSelector.init();

import { gsap } from "gsap/all";
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

// Load utils
import { debounce, updateLayoutVars, setCSSVar, escapeAttribute, runScripts } from "./tools/utils";
import { gridDebug } from "./tools/gridDebug";
import { Modal } from "./components/Modal";

// Load components
import { BurgerMenu } from "./components/burgerMenu";

const isDesktop = () => window.matchMedia("(min-width: 1061px)").matches;

window.clinicMapStyle = [
	// 1. Masquer tous les points d'intérêt (commerces, attractions, etc.)
	{
		featureType: "poi",
		elementType: "all",
		stylers: [{ visibility: "off" }],
	},
	// 2. Masquer les éléments de transport (gares, etc.)
	{
		featureType: "transit",
		elementType: "all",
		stylers: [{ visibility: "off" }],
	},
	// 3. MONTAGNES : Masquer les labels et icônes du paysage naturel
	{
		featureType: "landscape.natural",
		elementType: "labels",
		stylers: [{ visibility: "off" }],
	},
	{
		featureType: "landscape.natural.terrain",
		elementType: "all",
		stylers: [{ visibility: "off" }],
	},
	// 4. VILLES : S'assurer que les noms de villes et régions sont visibles
	{
		featureType: "administrative",
		elementType: "labels",
		stylers: [{ visibility: "on" }],
	},
	// 5. Gérer les couleurs de fond (vos styles)
	{
		featureType: "water",
		elementType: "all",
	},
	{
		featureType: "landscape.natural",
		elementType: "geometry",
	},
	// 6. Routes
	{
		featureType: "road",
		elementType: "all",
		stylers: [{ lightness: 60 }, { saturation: -100 }],
	},
	{
		featureType: "road.highway",
		elementType: "all",
		stylers: [{ visibility: "simplified" }],
	},
	// 7. Parcs (on garde la géométrie verte mais sans les icônes de sapins/labels)
	{
		featureType: "poi.park",
		elementType: "geometry",
		stylers: [{ visibility: "on" }],
	},
	{
		featureType: "poi.park",
		elementType: "labels",
		stylers: [{ visibility: "off" }],
	},
];

window.clinicInfoWindowTemplate = function (clinic) {
	let rdvButtonHtml = "";
	rdvButtonHtml = `
		<button
			type="button"
			class="btn btn--white has-calendar-icon js-clinic-open-rdv"
			data-selected-clinic="${clinic.post_id || ""}"
			data-onedoc-id="${clinic.onedoc_id || ""}"
			data-onedoc-script="${escapeAttribute(clinic.onedoc_script)}"
			data-ephysio-id="${clinic.ephysio_id || ""}"
		>
			<span class="btn__label">${themeVars.strings.take_rdv}</span>
			<span class="btn__bg"></span>
		</button>
	`;

	return `
		<div class="gm-style-ctn">
			<div class="gm-style-title h4 is-white">
				${clinic.post_title}
			</div>

			${
				clinic.address
					? `
				<div class="gm-style-address">
					<a href="https://www.google.com/maps/place/?q=place_id:${clinic.gmb_place_id}" target="_blank" rel="noopener">${clinic.address}</a>
				</div>
			`
					: ""
			}

			${
				clinic.phone
					? `
				<div class="gm-style-phone">
					<a href="tel:${clinic.phone_callable}">${clinic.phone}</a>
				</div>
			`
					: ""
			}

			<div class="gm-style-btns">
				${rdvButtonHtml}
				<a
					href="${clinic.permalink}"
					target="_blank"
					rel="noopener"
					class="btn btn--primary"
				>
					<span class="btn__label">${themeVars.strings.see_clinic}</span>
					<span class="btn__bg"></span>
				</a>
			</div>
		</div>
	`;
};

window.addEventListener(
	"message",
	(event) => {
		if (event.data == null) return;
		let data = event.data;
		if (typeof data === "string") {
			try {
				data = JSON.parse(data);
			} catch {
				return;
			}
		}
		const iframe = document.getElementById("t-booking");
		if (!iframe || !data || data.height == null) return;
		const height = Number(data.height);
		if (!Number.isFinite(height)) return;
		iframe.style.height = `${height}px`;
		// window.scrollTo(0, 0);
	},
	false,
);

document.addEventListener("DOMContentLoaded", (e) => {
	// Load grid debug on dev environement
	if (themeVars.is_dev) gridDebug.init();

	// update layout vars
	updateLayoutVars();
	window.addEventListener("resize", debounce(updateLayoutVars, 150));

	// Init components
	BurgerMenu.init();
	Modal.init();

	// Input "Au cabinet"
	const cabinetInput = document.querySelector('input.gfield-choice-input[value="cabinet"]');

	// BTN hover
	const buttons = document.querySelectorAll(".btn");

	buttons.forEach((btn) => {
		const btnBg = btn.querySelector(".btn__bg");

		if (!btnBg) return;

		const setPosition = (e) => {
			const rect = btn.getBoundingClientRect();

			btnBg.style.left = `${e.clientX - rect.left}px`;
			btnBg.style.top = `${e.clientY - rect.top}px`;
		};

		btn.addEventListener("mouseenter", setPosition);
		btn.addEventListener("mousemove", setPosition);
		btn.addEventListener("mouseleave", setPosition);
	});

	function initFileInput(input) {
		if (input.dataset.fileProxyInit) return;
		input.dataset.fileProxyInit = "1";

		const container = input.closest(".ginput_container_fileupload") || input.parentElement;
		const placeholder = input.getAttribute("placeholder") || "\u00A0";

		const proxy = document.createElement("span");
		proxy.className = "file-input-proxy";
		proxy.setAttribute("aria-hidden", "true");
		proxy.textContent = placeholder;
		container.insertBefore(proxy, input);

		const setFile = (name) => {
			proxy.textContent = name || placeholder;
			proxy.classList.toggle("has-file", !!name);
			if (name) input.closest(".gfield")?.classList.add("label-is-floating");
		};

		// Reflect a file already uploaded (GF async upload preview)
		const syncFromPreview = () => {
			const firstName = container.querySelector(".gfield_fileupload_filename")?.textContent?.trim();
			const count = container.querySelectorAll(".ginput_preview").length;
			if (count > 1) setFile(`${count} fichiers`);
			else if (firstName) setFile(firstName);
		};

		syncFromPreview();

		input.addEventListener("change", () => {
			const files = Array.from(input.files);
			if (files.length === 1) setFile(files[0].name.replace(/.*[\/\\]/, ""));
			else if (files.length > 1) setFile(`${files.length} fichiers`);
			else setFile(null);
		});

		// Watch GF async upload preview list mutations
		const previewList = container.querySelector(".ginput_preview_list");
		if (previewList) {
			new MutationObserver(syncFromPreview).observe(previewList, { childList: true, subtree: true });
		}
	}

	const initAllFileInputs = () => document.querySelectorAll('input[type="file"]').forEach(initFileInput);
	initAllFileInputs();

	// Re-init after GF re-renders the form (validation errors, page turns)
	if (window.jQuery) {
		window.jQuery(document).on("gform_post_render", initAllFileInputs);
	}

	let lastGravityFormScroll = 0;
	const scrollToGravityFormsFeedback = (formId) => {
		const now = Date.now();
		if (now - lastGravityFormScroll < 250) return;

		const wrapper = formId ? document.querySelector(`#gform_wrapper_${formId}`) : null;
		const target = wrapper ? wrapper.querySelector(".gform_confirmation_message, .gform_validation_errors") : document.querySelector(".gform_confirmation_message, .gform_validation_errors");

		if (!target) return;

		lastGravityFormScroll = now;

		const cssHeaderHeight = parseFloat(getComputedStyle(document.body).getPropertyValue("--_header-h"));
		const headerHeight = Number.isFinite(cssHeaderHeight) ? cssHeaderHeight : document.querySelector(".header")?.offsetHeight || 0;
		const targetRect = target.getBoundingClientRect();
		const visibleViewportHeight = Math.max(window.innerHeight - headerHeight, 0);
		const visibleCenterY = headerHeight + visibleViewportHeight / 2;
		const top = window.scrollY + targetRect.top - (visibleCenterY - targetRect.height / 2);

		window.scrollTo({
			top: Math.max(0, top),
			behavior: "smooth",
		});
	};

	if (window.jQuery) {
		window.jQuery(document).on("gform_confirmation_loaded", (_event, formId) => {
			window.requestAnimationFrame(() => scrollToGravityFormsFeedback(formId));
		});
	}

	const setupModalDatepickerPositioning = () => {
		const ensureDatepickerToggles = (root = document) => {
			root.querySelectorAll("input.gform-datepicker").forEach((input) => {
				const container = input.closest(".ginput_container_date") || input.parentElement;
				if (!container || container.querySelector("button.gform-datepicker-toggle")) return;

				const button = document.createElement("button");
				button.type = "button";
				button.id = `datepicker_toggle_${input.id}`;
				button.className = "gform-datepicker-toggle gform-datepicker-toggle--default accCalendar aria-date-picker";
				button.setAttribute("aria-expanded", "false");
				button.setAttribute("aria-controls", input.id);
				button.setAttribute("aria-label", "Choisir une date");
				button.innerHTML = '<span class="gform-datepicker-toggle-icon" aria-hidden="true"></span>';
				container.appendChild(button);
			});
		};

		ensureDatepickerToggles();

		if (window.gform?.utils?.addFilter) {
			window.gform.utils.addFilter("gform/datepicker/pre_init", (payload) => {
				if (payload?.options) {
					payload.options.openOnFocus = true;
					payload.options.helpTextShort = "";
					payload.options.helpText = "";
					payload.options.openOnFocusHelpText = "";
				}
				return payload;
			});
		}

		let activeDateInput = null;
		let activeScrollContainer = null;
		let rafId = null;

		const getDatepicker = () => {
			const calendar = document.querySelector(".gform-datepicker-calendar:not([hidden])");
			if (calendar) return calendar;

			const legacy = document.getElementById("ui-datepicker-div");
			if (legacy && legacy.style.display !== "none") return legacy;

			return null;
		};

		const resetActiveInput = () => {
			activeDateInput = null;
			if (activeScrollContainer) {
				activeScrollContainer.removeEventListener("scroll", queuePositionUpdate);
				activeScrollContainer = null;
			}
		};

		const queuePositionUpdate = () => {
			if (rafId) window.cancelAnimationFrame(rafId);
			rafId = window.requestAnimationFrame(updateDatepickerPosition);
		};

		const updateDatepickerPosition = () => {
			rafId = null;

			if (!activeDateInput || !document.body.contains(activeDateInput)) {
				resetActiveInput();
				return;
			}

			const modal = activeDateInput.closest(".modal.is-visible");
			if (!modal) {
				resetActiveInput();
				return;
			}

			const datepicker = getDatepicker();
			if (!datepicker) return;

			const inputRect = activeDateInput.getBoundingClientRect();
			const pickerRect = datepicker.getBoundingClientRect();
			const gutter = 8;
			let top = inputRect.bottom + gutter;
			let left = inputRect.left;

			// Keep the picker inside viewport when opened near edges.
			if (top + pickerRect.height > window.innerHeight - gutter) {
				top = Math.max(gutter, inputRect.top - pickerRect.height - gutter);
			}

			const maxLeft = Math.max(gutter, window.innerWidth - pickerRect.width - gutter);
			left = Math.min(Math.max(gutter, left), maxLeft);

			datepicker.style.position = "fixed";
			datepicker.style.top = `${Math.round(top)}px`;
			datepicker.style.left = `${Math.round(left)}px`;
			datepicker.style.zIndex = "9999";
		};

		const setActiveInput = (input) => {
			const modal = input?.closest(".modal.is-visible");
			if (!modal) {
				resetActiveInput();
				return;
			}

			activeDateInput = input;

			const nextScrollContainer = modal.querySelector(".modal__dialog");
			if (activeScrollContainer !== nextScrollContainer) {
				if (activeScrollContainer) {
					activeScrollContainer.removeEventListener("scroll", queuePositionUpdate);
				}
				activeScrollContainer = nextScrollContainer;
				if (activeScrollContainer) {
					activeScrollContainer.addEventListener("scroll", queuePositionUpdate, { passive: true });
				}
			}

			queuePositionUpdate();
			window.setTimeout(queuePositionUpdate, 0);
			window.setTimeout(queuePositionUpdate, 50);
		};

		document.addEventListener("focusin", (event) => {
			const input = event.target.closest("input.gform-datepicker");
			if (!input) return;
			setActiveInput(input);
		});

		document.addEventListener("click", (event) => {
			const trigger = event.target.closest("button.gform-datepicker-toggle, img.ui-datepicker-trigger");
			if (!trigger) return;

			const input = trigger.parentElement?.querySelector("input.gform-datepicker");
			if (!input) return;
			setActiveInput(input);
		});

		document.addEventListener("click", (event) => {
			if (!event.target.closest(".gform-datepicker-calendar, #ui-datepicker-div .ui-datepicker-prev, #ui-datepicker-div .ui-datepicker-next, #ui-datepicker-div .ui-datepicker-title select")) return;
			window.setTimeout(queuePositionUpdate, 0);
		});

		window.addEventListener("resize", queuePositionUpdate);
		window.addEventListener("scroll", queuePositionUpdate);

		if (window.jQuery) {
			window.jQuery(document).on("gform_post_render gform_page_loaded", (_event, formId) => {
				const form = formId ? document.getElementById(`gform_${formId}`) : document;
				ensureDatepickerToggles(form || document);
				window.requestAnimationFrame(queuePositionUpdate);
			});
		}
	};

	setupModalDatepickerPositioning();

	document.addEventListener("gform_confirmation_loaded", (event) => {
		const formId = event?.detail?.formId || event?.detail || null;
		window.requestAnimationFrame(() => scrollToGravityFormsFeedback(formId));
	});

	// Observe header
	const header = document.querySelector(".header");
	const header_ban = document.querySelector(".header-ban-info");
	const container = document.querySelector(".site-container");

	if (header) {
		setCSSVar("--_header-h", `${header.offsetHeight}px`, "body");
		if (header_ban) {
			setCSSVar("--_header-ban-h", `${header_ban.offsetHeight}px`, "body");
		}

		window.addEventListener("scroll", () => document.body.classList.toggle("header-is-sticky", window.scrollY > header.offsetHeight));

		window.addEventListener("scroll", () => {
			const containerRect = container.getBoundingClientRect();
			const headerHeight = header.offsetHeight;

			// si le header dépasse le bas du container
			if (containerRect.bottom + 50 <= headerHeight) {
				header.classList.add("is-hidden");
			} else {
				header.classList.remove("is-hidden");
			}
		});
	}

	// Subnav stuffs
	const nav = document.querySelector(".main-nav");
	if (nav) {
		const toggleBodyClass = (add) => {
			document.body.classList.toggle("has-subnav-open", add);
		};

		// Desktop nav
		nav.addEventListener("mouseover", (e) => {
			if (!isDesktop()) return;

			const menuItem = e.target.closest(".main-nav__item.menu-item-has-children");
			if (!menuItem || !nav.contains(menuItem)) return;

			toggleBodyClass(true);
		});

		nav.addEventListener("mouseout", (e) => {
			if (!isDesktop()) return;

			const menuItem = e.target.closest(".main-nav__item.menu-item-has-children");
			if (!menuItem || !nav.contains(menuItem)) return;

			if (menuItem.matches(":hover")) return;

			toggleBodyClass(false);
		});

		// Mobilde nav
		nav.addEventListener("click", (e) => {
			if (isDesktop()) return;

			const trigger = e.target.closest(".main-nav__trigger-drop, .main-nav__link");
			if (!trigger) return;

			const menuItem = trigger.closest(".main-nav__item");
			if (!menuItem || !menuItem.classList.contains("menu-item-has-children")) return;

			e.preventDefault();

			const isOpen = menuItem.classList.contains("is-open");

			// Ferme les autres sous-menus
			nav.querySelectorAll(".main-nav__item.is-open").forEach((item) => {
				item.classList.remove("is-open");
			});

			// Toggle le courant
			menuItem.classList.toggle("is-open", !isOpen);

			// Body class si au moins un subnav ouvert
			toggleBodyClass(!isOpen);
		});
	}

	// Language trigger
	const lang_trigger = document.querySelector(".js-open-lang");
	if (lang_trigger) {
		lang_trigger.addEventListener("click", (e) => {
			e.preventDefault();
			document.querySelector(".lang-switcher").classList.toggle("is-open");
		});
	}

	gsap.fromTo(
		".footer-ctn",
		{
			backgroundPosition: "right 250%",
		},
		{
			backgroundPosition: "right 100%",
			ease: "power2.in",
			scrollTrigger: {
				trigger: ".gsap-footer-trigger",
				start: "top 100%",
				end: "bottom 20%",
				scrub: 1,
			},
		},
	);

	const setBookingModalTitle = (modal, text) => {
		const title = modal?.querySelector(".modal__title");
		if (!title) return;
		title.textContent = text || "";
		title.hidden = !text;
	};

	// Liens tbooking écrits en dur dans le contenu (ex. pages urgences) : ouverture en popin au lieu d'un nouvel onglet
	document.addEventListener("click", (e) => {
		const link = e.target.closest('a[href*="tbooking.ch/fr/book/"]');
		if (!link || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;

		const match = link.href.match(/tbooking\.ch\/fr\/book\/([^/?#]+)(#.*)?$/);
		const modal = document.querySelector(".modal[data-modal='onedoc_appointment']");
		const modalContent = modal?.querySelector(".modal__content");
		if (!match || !modalContent) return;

		e.preventDefault();

		setBookingModalTitle(modal, modal.dataset.urgentTitle);
		const bookingSrc = `https://www.tbooking.ch/fr/book/${match[1]}?embedded=true&primary-color=3c7bc8&secondary-color=0274be${match[2] || ""}`;
		modalContent.innerHTML = `<iframe id="t-booking" src="${bookingSrc}" style="width:100%;" allow="camera *;"></iframe>`;
		modal.classList.add("is-visible");
		modal.setAttribute("aria-hidden", "false");
	});

	document.addEventListener("click", (e) => {
		const pickerTrigger = e.target.closest(".js-clinic-rdv-picker");
		if (pickerTrigger) {
			e.preventDefault();

			if (usesNativeClinicPicker() || !clinicRdvMenu) {
				openClinicRdvNativePicker();
			} else {
				toggleClinicRdvMenu(pickerTrigger);
			}
			return;
		}

		if (!e.target.closest("#clinic-rdv-menu")) {
			closeClinicRdvMenu();
		}

		let btn = e.target.closest(".js-clinic-open-rdv");
		if (btn) {
			e.preventDefault();
			closeClinicRdvMenu();
			openClinicRdv({
				selectedClinic: btn.dataset.selectedClinic || "",
				onedocId: btn.dataset.onedocId || "",
				onedocScript: btn.dataset.onedocScript || "",
				ephysioId: btn.dataset.ephysioId || "",
			});
		}

		// If the clicked button has data-domicile="true", check input with value="domicile"
		let btn_rdv = e.target.closest(".btn[data-modal-trigger='rdv']");
		if (btn_rdv) {
			const domicileInput = document.querySelector('input.gfield-choice-input[value="domicile"]');

			if (domicileInput) {
				if (btn_rdv.dataset.domicile === "true") {
					domicileInput.checked = true;
				} else {
					domicileInput.checked = false;
				}
			}

			if (cabinetInput) {
				if (btn_rdv.dataset.domicile === "true") {
					cabinetInput.checked = false;
				} else {
					cabinetInput.checked = true;
				}
			}

			// Optionally trigger change event
			const event = new Event("change", { bubbles: true });
			domicileInput.dispatchEvent(event);
		}

		// Check if the clicked element is .vc_tta-controls-icon inside a .vc_tta-panel
		const controlsIcon = e.target.closest(".vc_tta-controls-icon");
		const panel = controlsIcon ? controlsIcon.closest(".vc_tta-panel") : null;

		if (panel && !panel.classList.contains("vc_animating") && panel.classList.contains("vc_active")) {
			if (controlsIcon && panel.contains(controlsIcon)) {
				panel.classList.remove("vc_active");
			}
		}
	});

	const clinicRdvNativeSelect = document.getElementById("clinic-rdv-native-select");
	const clinicRdvMenu = document.getElementById("clinic-rdv-menu");
	let clinicRdvMenuTrigger = null;

	// Phones keep the native select: easier to reach with a thumb, and no viewport clipping.
	const usesNativeClinicPicker = () => window.matchMedia("(max-width: 768px)").matches;

	function positionClinicRdvMenu() {
		if (!clinicRdvMenu || !clinicRdvMenuTrigger) return;

		const gutter = 16;
		const offset = 8;
		const rect = clinicRdvMenuTrigger.getBoundingClientRect();
		const menuWidth = clinicRdvMenu.offsetWidth;
		const menuHeight = clinicRdvMenu.offsetHeight;

		const maxLeft = Math.max(window.innerWidth - menuWidth - gutter, gutter);
		const left = Math.min(Math.max(rect.left, gutter), maxLeft);

		const fitsBelow = window.innerHeight - rect.bottom > menuHeight + gutter;
		const top = fitsBelow ? rect.bottom + offset : Math.max(rect.top - menuHeight - offset, gutter);

		clinicRdvMenu.style.insetInlineStart = `${left}px`;
		clinicRdvMenu.style.insetBlockStart = `${top}px`;
	}

	function openClinicRdvMenu(trigger) {
		if (!clinicRdvMenu) return;

		clinicRdvMenuTrigger = trigger;
		clinicRdvMenu.classList.add("is-open");
		clinicRdvMenu.setAttribute("aria-hidden", "false");
		trigger.setAttribute("aria-expanded", "true");

		positionClinicRdvMenu();
		clinicRdvMenu.querySelector(".clinic-rdv-menu__item")?.focus();
	}

	function closeClinicRdvMenu() {
		if (!clinicRdvMenu || !clinicRdvMenu.classList.contains("is-open")) return;

		clinicRdvMenu.classList.remove("is-open");
		clinicRdvMenu.setAttribute("aria-hidden", "true");
		clinicRdvMenuTrigger?.setAttribute("aria-expanded", "false");
		clinicRdvMenuTrigger = null;
	}

	function toggleClinicRdvMenu(trigger) {
		if (clinicRdvMenu?.classList.contains("is-open") && clinicRdvMenuTrigger === trigger) {
			closeClinicRdvMenu();
			return;
		}

		closeClinicRdvMenu();
		openClinicRdvMenu(trigger);
	}

	if (clinicRdvMenu) {
		document.querySelectorAll(".js-clinic-rdv-picker").forEach((trigger) => {
			trigger.setAttribute("aria-haspopup", "true");
			trigger.setAttribute("aria-expanded", "false");
		});

		clinicRdvMenu.addEventListener("keydown", (e) => {
			if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;

			e.preventDefault();

			const items = [...clinicRdvMenu.querySelectorAll(".clinic-rdv-menu__item")];
			const current = items.indexOf(document.activeElement);
			const next = e.key === "ArrowDown" ? current + 1 : current - 1;

			items[(next + items.length) % items.length]?.focus();
		});

		document.addEventListener("keydown", (e) => {
			if (e.key !== "Escape") return;

			const trigger = clinicRdvMenuTrigger;
			closeClinicRdvMenu();
			trigger?.focus();
		});

		window.addEventListener("scroll", () => positionClinicRdvMenu(), { passive: true });
		window.addEventListener("resize", debounce(positionClinicRdvMenu, 100));
	}

	function openClinicRdv({ selectedClinic = "", onedocId = "", onedocScript = "", ephysioId = "" } = {}) {
		let modal = null;
		setBookingModalTitle(document.querySelector(".modal[data-modal='onedoc_appointment']"), "");

		if (ephysioId !== "") {
			modal = document.querySelector(".modal[data-modal='onedoc_appointment']");
			if (!modal) return;

			const modalContent = modal.querySelector(".modal__content");
			if (modalContent) {
				const bookingSrc = `https://www.tbooking.ch/fr/book/${encodeURIComponent(ephysioId)}?embedded=true&primary-color=3c7bc8&secondary-color=0274be`;
				modalContent.innerHTML = `<iframe id="t-booking" src="${bookingSrc}" style="width:100%;" allow="camera *;"></iframe>`;
			}
		} else if (onedocId !== "") {
			modal = document.querySelector(".modal[data-modal='onedoc_appointment']");
			if (!modal) return;

			const modalContent = modal.querySelector(".modal__content");
			if (modalContent) {
				modalContent.innerHTML = `
					<iframe
						class="od-widget"
						id="od-widget-${onedocId}"
						src="https://onedoc.ch/fr/widget/${onedocId}"
						frameborder="0"
						style="width:100%;max-width:1024px;height:400px"
					></iframe>
					`;

				runScripts(onedocScript, modalContent);
			}
		} else {
			modal = document.querySelector(".modal[data-modal='rdv']");
			if (!modal) return;

			const selectWrapper = modal.querySelector(".gfield.selected_clinic");
			if (!selectWrapper) return;

			const select = selectWrapper.querySelector("select");
			if (select && selectedClinic) {
				Array.from(select.options).forEach((option) => {
					option.selected = option.value === selectedClinic;
				});

				const event = new Event("change", { bubbles: true });
				select.dispatchEvent(event);
			}
		}

		if (modal) {
			modal.classList.add("is-visible");
		}
	}

	function openClinicRdvNativePicker() {
		if (!clinicRdvNativeSelect) return;

		clinicRdvNativeSelect.value = "";

		try {
			if (typeof clinicRdvNativeSelect.showPicker === "function") {
				clinicRdvNativeSelect.showPicker();
				return;
			}
		} catch {
			// showPicker can throw if not triggered by a user gesture in some browsers
		}

		// Fallback: briefly make the select interactable then open it
		clinicRdvNativeSelect.style.pointerEvents = "auto";
		clinicRdvNativeSelect.style.blockSize = "auto";
		clinicRdvNativeSelect.style.opacity = "0.01";
		clinicRdvNativeSelect.focus();
		clinicRdvNativeSelect.click();
		requestAnimationFrame(() => {
			clinicRdvNativeSelect.style.pointerEvents = "";
			clinicRdvNativeSelect.style.blockSize = "";
			clinicRdvNativeSelect.style.opacity = "";
		});
	}

	if (clinicRdvNativeSelect) {
		clinicRdvNativeSelect.addEventListener("change", () => {
			const option = clinicRdvNativeSelect.selectedOptions[0];
			if (!option || !option.value) return;

			openClinicRdv({
				selectedClinic: option.value,
				onedocId: option.dataset.onedocId || "",
				onedocScript: option.dataset.onedocScript || "",
				ephysioId: option.dataset.ephysioId || "",
			});

			clinicRdvNativeSelect.value = "";
		});
	}

	new PerformanceObserver((list) => {
		const latestEntry = list.getEntries().at(-1);

		if (latestEntry?.element?.getAttribute("loading") == "lazy") {
			console.warn("Warning: LCP element was lazy loaded", latestEntry);
		}
	}).observe({ type: "largest-contentful-paint", buffered: true });

	// Auto check "Au cabinet" input
	if (cabinetInput) {
		cabinetInput.checked = true;
	}
});

window.addEventListener("load", () => {
	ScrollTrigger.refresh();
});
